import React from 'react'
import { connect } from 'react-redux'
import { isEmpty } from 'lodash'
import CartItem from './CartItem'

const Cart = (props) => {

    const { cart, orderedCartArray, cartChangeToken, cartLoading, noSpace = false } = props
    let cartArrayUi = []

    for (let key of orderedCartArray) {
        const itemArray = cart[key]

        let itemUi = itemArray.map((config) => {
            return (
                <CartItem key={config.configId} config={config} cartLoading={cartLoading} noSpace={noSpace} />
            )
        })

        cartArrayUi.push(itemUi)
    }

    return (
        <div>
            <span style={{ display: 'none' }}>{cartChangeToken}</span>
            {cartArrayUi}
        </div>
    )



}

const mapStateToProps = (state) => {
    const { cartChangeToken, cartLoading } = state.user
    const cart = { ...state.user.cart }
    const isCartEmpty = isEmpty(cart)
    const orderedCartArray = []
    let qty = 0, price = 0;

    for (let key in cart) {
        orderedCartArray.push(key)
        const itemArray = cart[key]
        for (let i = 0; i < itemArray.length; i++) {
            const config = itemArray[i]
            const configQty = parseInt(config.quantity);
            qty += configQty;
            const configPrice = parseInt(config.totalPrice);
            price = price + (parseInt(configPrice) * configQty)
        }
    }

    orderedCartArray.sort()


    return { cart, orderedCartArray, cartChangeToken, cartLoading, isCartEmpty, qty, price }
}

export default connect(mapStateToProps, {})(Cart)